/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'

import { apiCall } from './api'

export const GET_MONTHLY_LISTENERS = createAsyncAction(
  'GET_TOTAL_PAYMENT_PERIOD'
)
export const getMonthlyListeners = (token: string, callback: () => void) =>
  apiCall({
    method: 'post',
    endpoint: `/admin/get-monthly-listeners`,
    query: {
      token,
    },
    types: GET_MONTHLY_LISTENERS,
    callback,
  })
